<template>
    <div class="form-info">
        <div class="form-row" style="height: 120px">
            <div class="form-label">
                <label>图片展示</label>
            </div>
            <div class="form-value width-3x">
                <div class="file-area small-picture clearfix">
                    <div class="file-item image viewable" v-for="fileUrl in servcReqVoucherFileUrls">
                        <div class="file-content">
                            <img :src="fileUrl"/>
                            <div class="operation-group" @click="showImg(fileUrl)">
                                <i class="icon iconfont icon-chakan view"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDisptApi from '../../api/servcDispt'

    export default{
        name: 'swb-servc-req-voucher-file-detail',
        desc: '服务请求单附件详情',
        props: ['reqVoucherId'],
        data: function () {
            return {
                servcReqVoucherFileUrls: []
            }
        },
        created: function () {
            //
            this.getServcReqVoucherFileDetail();
        },
        methods: {
            getServcReqVoucherFileDetail: function () {
                let self = this;
                let postData = {};
                postData.reqVoucherId = this.reqVoucherId;
                let theLoad = MsgBox.loading();
                servcDisptApi.getServcReqVoucherFileUrlList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.servcReqVoucherFileUrls = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            showImg: function (url) {
                setPageUrl(url, "_bank");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcReq/ServcReqVoucherFileDetail.vue